import { toast as sonnerToast, ExternalToast } from "sonner";
import * as React from "react";

/**
 * Wrapper de compatibilidade: mantém a API do useToast shadcn
 * mas usa Sonner internamente para renderização.
 * 
 * Isso permite que todo o código existente continue funcionando
 * sem alterações, enquanto unificamos em um único sistema de toasts.
 */

type ToastVariant = "default" | "destructive";

interface ToastOptions {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: ToastVariant;
  action?: React.ReactNode;
  duration?: number;
}

// Converte a API shadcn para Sonner
function toast(options: ToastOptions) {
  const { title, description, variant, duration } = options;

  // Monta a mensagem (Sonner usa message como primeiro argumento)
  const message = title || description || "";

  // Opções do Sonner
  const sonnerOptions: ExternalToast = {
    description: title && description ? String(description) : undefined,
    duration: duration ?? 5000,
  };

  // Dispatch baseado na variante
  if (variant === "destructive") {
    return sonnerToast.error(message as string, sonnerOptions);
  }

  return sonnerToast(message as string, sonnerOptions);
}

// Hook de compatibilidade - apenas re-exporta o toast
// Mantém a mesma interface para não quebrar código existente
function useToast() {
  return {
    toast,
    // Dismiss all toasts
    dismiss: (toastId?: string | number) => {
      if (toastId !== undefined) {
        sonnerToast.dismiss(toastId);
      } else {
        sonnerToast.dismiss();
      }
    },
    // Lista vazia de toasts (Sonner gerencia internamente)
    toasts: [] as never[],
  };
}

export { useToast, toast };
